import React from "react";
import Select, { Option } from "rc-select";
import "rc-select/assets/index.css";
import { countries } from "./countries";
const arrowPath =
  "M632 888H392c-4.4 0-8 3.6-8 8v32c0 " +
  "17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-3" +
  "2c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-3" +
  "28 328 0 121.4 66 227.4 164 284.1V792c0 17.7 1" +
  "4.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98" +
  "-56.7 164-162.7 164-284.1 0-181.1-146.9-328-32" +
  "8-328z m127.9 549.8L604 634.6V752H420V634.6l-3" +
  "5.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4" +
  " 114.6-256 256-256s256 114.6 256 256c0 92.5-49" +
  ".4 176.3-128.1 221.8z";

const clearPath =
  "M793 242H366v-74c0-6.7-7.7-10.4-12.9" +
  "-6.3l-142 112c-4.1 3.2-4.1 9.4 0 12.6l142 112c" +
  "5.2 4.1 12.9 0.4 12.9-6.3v-74h415v470H175c-4.4" +
  " 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-" +
  "28.7 64-64V306c0-35.3-28.7-64-64-64z";

const menuItemSelectedIcon = props => {
  const { ...p } = props;
  return (
    <span style={{ position: "absolute", right: 0 }}>
      {p.isSelected ? (
        <i className="material-icons">done</i>
      ) : (
        <i className="material-icons">crop_square</i>
      )}
    </span>
  );
};

const getSvg = path => {
  return (
    <i>
      <svg
        viewBox="0 0 1024 1024"
        width="1em"
        height="1em"
        fill="currentColor"
        style={{ verticalAlign: "-.125em " }}
      >
        <path d={path} p-id="5827" />
      </svg>
    </i>
  );
};

export default function GetAreas(props) {
  const dropdownMenuStyle = {
    maxHeight: 200
  };
  return (
    <Select
      className="areas-select insertfactory"
      // animation={"slide-up"}
      choiceTransitionName="rc-select-selection__choice-zoom"
      dropdownMenuStyle={dropdownMenuStyle}
      // multiple
      allowClear
      optionFilterProp="children"
      optionLabelProp="children"
      // placeholder="انتخاب ناحیه"
      onChange={e => props.getvalue(e)}
      tokenSeparators={[" ", ","]}
      inputIcon={getSvg(arrowPath)}
      clearIcon={getSvg(clearPath)}
      removeIcon={getSvg(clearPath)}
      menuItemSelectedIcon={menuItemSelectedIcon}
      required
      notFoundContent="نتیجه ای پیدانشد"
      filterOption={true}
      loading={true}
      style={{ width: "98%", margin: "10px auto 0", display: "block" }}
    >
      {countries.map((row, i) => (
        <Option title={row.name} value={row.name} key={i}>
          {row.name}
          <span className={"css_flag css_" + row.code}>
            {/* <span className={"css_flag css_" + row.code}>
            <span>{row.name}</span>
          </span> */}
          </span>
        </Option>
      ))}
    </Select>
  );
}
